"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var StaticWrapper_1 = require("./StaticWrapper");
var ModalWrapper_1 = require("./ModalWrapper");
var InlineWrapper_1 = require("./InlineWrapper");
function getWrapperFromVariant(variant) {
    switch (variant) {
        case 'inline':
            return InlineWrapper_1.InlineWrapper;
        case 'static':
            return StaticWrapper_1.StaticWrapper;
        default:
            return ModalWrapper_1.ModalWrapper;
    }
}
exports.getWrapperFromVariant = getWrapperFromVariant;
exports.VariantContext = React.createContext(null);
exports.Wrapper = function (_a) {
    var variant = _a.variant, props = __rest(_a, ["variant"]);
    var Component = getWrapperFromVariant(variant);
    return (React.createElement(exports.VariantContext.Provider, { value: variant || 'dialog' },
        React.createElement(Component, __assign({}, props))));
};
